import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import { setupRouter } from './router'
import './router/routerHooks'
import { setupStore } from './store'
// animate.css
import '@/plugins/animate.css'
// 全局组件
import { setupGlobCom } from '@/components'

// 初始样式
import '@/styles/index.scss'
// windiCss
import '@/plugins/windi.css'

import VueDOMPurifyHTML from 'vue-dompurify-html' // 防xss攻击
// Vform-designer
import 'virtual:svg-icons-register'
// import 'element-plus/theme-chalk/dark/css-vars.css'
import { directivesList } from '@/directives/index'

const setupAll = async () => {
  const app = createApp(App)

  setupStore(app)

  setupRouter(app)

  app.use(VueDOMPurifyHTML)

  app.use(ElementPlus)

  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component as any)
  }

  for (const [key, directive] of Object.entries(directivesList)) {
    app.directive(key, directive)
  }

  setupGlobCom(app)

  const win: any = window

  if (process.env.NODE_ENV === 'development') {
    if ('__VUE_DEVTOOLS_GLOBAL_HOOK__' in win) {
      win.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app
    }
  }

  app.mount('#app')
}

setupAll()
